import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAdminAuth } from '../context/AdminAuthContext';
import PageLoader from '@/components/base/PageLoader';

interface Props {
  children: ReactNode;
}

export default function AdminGuard({ children }: Props) {
  const { isLoggedIn, loading, configError } = useAdminAuth();

  if (loading) {
    return <PageLoader title="Checking admin session" message="Verifying your admin access." />;
  }

  if (configError) {
    return (
      <div className="min-h-screen bg-[#111D2B] flex items-center justify-center px-6">
        <div className="w-full max-w-md bg-[#1C2B3A] border border-white/10 rounded-2xl p-8 text-center">
          <div
            className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-4 text-white"
            style={{ backgroundColor: 'var(--accent)' }}
          >
            <i className="ri-error-warning-line text-2xl"></i>
          </div>
          <p className="text-xl font-black text-white mb-2">Backend not configured</p>
          <p className="text-sm text-white/60">{configError}</p>
        </div>
      </div>
    );
  }

  if (!isLoggedIn) {
    return <Navigate to="/admin/login" replace />;
  }
  return <>{children}</>;
}
